var lib_core  = require("lib-core");

var Editor2DController = require("./../editor2D/editor2DController.js");
var Camera2DController = require("./../camera2D/camera2DController.js");
var OriginController = require("./../origin/originController.js");
var SelectionController = require("./../selection/selectionController.js");

var SnapModel = require("./snapModel.js");
var SnapView  = require("./snapView.js");

var SnapController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(SnapController, lib_core.Controller);
SnapController.inject = {
    editor2DController : Editor2DController,
    camera2DController : Camera2DController,
    originController : OriginController,
    selectionController : SelectionController
};

module.exports = SnapController;

SnapController.prototype.createModel = function () {
    var rules = this.configuration.rules || [];
    var editorModel = this.editor2DController.getModel();
    var cameraModel = this.camera2DController.getModel();
    var originModel = this.originController.getModel();
    var selectionModel = this.selectionController.getModel();
    return new SnapModel(editorModel, cameraModel, originModel, selectionModel, rules);
};

SnapController.prototype.createView = function () {
    var layer = this.configuration.layer;
    var editorView = this.editor2DController.getView();
    return new SnapView(editorView, this.getModel(), layer);
};
